import {
  GET_TIME_ENTRIES_LIST,
  GET_TIME_ENTRIES_LIST_SUCCESS,
  GET_TIME_ENTRIES_LIST_FAILURE,
  TIME_ENTRY_LIST_OPEN,
  TIME_ENTRY_LIST_OPEN_SUCCESS,
  TIME_ENTRY_LIST_OPEN_FAILURE,
  TIME_ENTRY_START,
  TIME_ENTRY_START_SUCCESS,
  TIME_ENTRY_START_FAILURE,
  TIME_ENTRY_STOP,
  TIME_ENTRY_STOP_SUCCESS,
  TIME_ENTRY_STOP_FAILURE,
  TIME_ENTRY_SEARCH_BY_STAFF_ID,
  TIME_ENTRY_SEARCH_BY_STAFF_ID_SUCCESS,
  TIME_ENTRY_SEARCH_BY_STAFF_ID_FAILURE,
  GET_TIME_ENTRY_TYPE_LIST,
  GET_TIME_ENTRY_TYPE_LIST_SUCCESS,
  GET_TIME_ENTRY_TYPE_LIST_FAILURE,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE_SUCCESS,
  TIME_ENTRY_SINGLE_ENTRY_UPDATE_FAILURE,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_SUCCESS,
  TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_FAILURE,
  TIME_ENTRY_REDUX_STATE_DATA,
  TIME_ENTRY_REDUX_STATE_DATA_SUCCESS,
  TIME_ENTRY_REDUX_STATE_DATA_FAILURE,
  TIMER_IS_RUNNING,
  TIMER_IS_RUNNING_SUCCESS,
  TIMER_IS_RUNNING_FAILURE,
  TIMER_STAFF_ID,
  TIMER_STAFF_ID_SUCCESS,
  TIMER_STAFF_ID_FAILURE,
  TIMER_TIME_ENTRY_START_DATE_TIME,
  TIMER_TIME_ENTRY_START_DATE_TIME_SUCCESS,
  TIMER_TIME_ENTRY_START_DATE_TIME_FAILURE,
  TIMER_TIME_ENTRY_END_DATE_TIME,
  TIMER_TIME_ENTRY_END_DATE_TIME_SUCCESS,
  TIMER_TIME_ENTRY_END_DATE_TIME_FAILURE,
  TIMER_JOB_ID,
  TIMER_JOB_ID_SUCCESS,
  TIMER_JOB_ID_FAILURE,
  TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID,
  TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_SUCCESS,
  TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_FAILURE,
  TIMER_BILLABLE_TYPE,
  TIMER_BILLABLE_TYPE_SUCCESS,
  TIMER_BILLABLE_TYPE_FAILURE,
  TIMER_NOTES,
  TIMER_NOTES_SUCCESS,
  TIMER_NOTES_FAILURE,
  TIME_ACTIVE_TAB,
  TIME_ACTIVE_TAB_SUCCESS,
  TIME_ACTIVE_TAB_FAILURE,
  PAUSE_TIMER,
  PAUSE_TIMER_SUCCESS,
  PAUSE_TIMER_FAILURE,
  ADD_PRODUCT_ID,
  ADD_PRODUCT_ID_SUCCESS,
  ADD_PRODUCT_ID_FAILURE,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  DELETE_SELECTED_TIME_ENTRIES,
  DELETE_SELECTED_TIME_ENTRIES_SUCCESS,
  DELETE_SELECTED_TIME_ENTRIES_FAILURE,
  ACTION_EVENT_FIRED,
  ACTION_EVENT_FIRED_SUCCESS,
  ACTION_EVENT_FIRED_FAILURE,
  TIME_ENTRY_LIST_SUMMARY_DAILY,
  TIME_ENTRY_LIST_SUMMARY_DAILY_SUCCESS,
  TIME_ENTRY_LIST_SUMMARY_DAILY_FAILURE,
  TIME_ENTRY_CREATE,
  TIME_ENTRY_CREATE_SUCCESS,
  TIME_ENTRY_CREATE_FAILURE,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_SUCCESS,
  TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_FAILURE,
} from "./actionType";

// Action Creator
// Get Time Entries List
export const getTimeEntriesList = () => ({
  type: GET_TIME_ENTRIES_LIST,
});

export const getTimeEntriesListSuccess = (timeEntries) => ({
  type: GET_TIME_ENTRIES_LIST_SUCCESS,
  payload: timeEntries,
});

export const getTimeEntriesListFailure = (error) => ({
  type: GET_TIME_ENTRIES_LIST_FAILURE,
  payload: error,
});

// Time Entry List / Open
export const timeEntryListOpen = (staff_id) => ({
  type: TIME_ENTRY_LIST_OPEN,
  payload: staff_id,
});

export const timeEntryListOpenSuccess = (timeEntries) => ({
  type: TIME_ENTRY_LIST_OPEN_SUCCESS,
  payload: timeEntries,
});

export const timeEntryListOpenFailure = (error) => ({
  type: TIME_ENTRY_LIST_OPEN_FAILURE,
  payload: error,
});

// Time Entry Start
export const timeEntryStart = (staff_id) => ({
  type: TIME_ENTRY_START,
  payload: staff_id,
});

export const timeEntryStartSuccess = (timeEntry) => ({
  type: TIME_ENTRY_START_SUCCESS,
  payload: timeEntry,
});

export const timeEntryStartFailure = (error) => ({
  type: TIME_ENTRY_START_FAILURE,
  payload: error,
});

// Time Entry Stop
export const timeEntryStop = (timeEntry) => ({
  type: TIME_ENTRY_STOP,
  payload: timeEntry,
});

export const timeEntryStopSuccess = (data) => ({
  type: TIME_ENTRY_STOP_SUCCESS,
  payload: data,
});

export const timeEntryStopFailure = (error) => ({
  type: TIME_ENTRY_STOP_FAILURE,
  payload: error,
});

// Time Entry Search by staff ID
export const timeEntrySearchByStaffId = (staff_id) => ({
  type: TIME_ENTRY_SEARCH_BY_STAFF_ID,
  payload: staff_id,
});

export const timeEntrySearchByStaffIdSuccess = (timeEntries) => ({
  type: TIME_ENTRY_SEARCH_BY_STAFF_ID_SUCCESS,
  payload: timeEntries,
});

export const timeEntrySearchByStaffIdFailure = (error) => ({
  type: TIME_ENTRY_SEARCH_BY_STAFF_ID_FAILURE,
  payload: error,
});

// Get Time Entry Type List
export const getTimeEntryTypeList = () => ({
  type: GET_TIME_ENTRY_TYPE_LIST,
});

export const getTimeEntryTypeListSuccess = (timeEntryTypes) => ({
  type: GET_TIME_ENTRY_TYPE_LIST_SUCCESS,
  payload: timeEntryTypes,
});

export const getTimeEntryTypeListFailure = (error) => ({
  type: GET_TIME_ENTRY_TYPE_LIST_FAILURE,
  payload: error,
});

// Time Entry Single Entry Update
export const timeEntrySingleEntryUpdate = (timeEntry) => ({
  type: TIME_ENTRY_SINGLE_ENTRY_UPDATE,
  payload: timeEntry,
});

export const timeEntrySingleEntryUpdateSuccess = (timeEntry) => ({
  type: TIME_ENTRY_SINGLE_ENTRY_UPDATE_SUCCESS,
  payload: timeEntry,
});

export const timeEntrySingleEntryUpdateFailure = (error) => ({
  type: TIME_ENTRY_SINGLE_ENTRY_UPDATE_FAILURE,
  payload: error,
});

// Time Entry Search with Today's Date
export const timeEntrySearchWithTodaysDate = (data) => ({
  type: TIME_ENTRY_SEARCH_WITH_TODAYS_DATE,
  payload: data,
});

export const timeEntrySearchWithTodaysDateSuccess = (
  timeEntrySearchTodaysDate
) => ({
  type: TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_SUCCESS,
  payload: timeEntrySearchTodaysDate,
});

export const timeEntrySearchWithTodaysDateFailure = (error) => ({
  type: TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_FAILURE,
  payload: error,
});

// Time Entry Redux State Data
export const timeEntryReduxStateData = (data) => ({
  type: TIME_ENTRY_REDUX_STATE_DATA,
  payload: data,
});

export const timeEntryReduxStateDataSuccess = (data) => ({
  type: TIME_ENTRY_REDUX_STATE_DATA_SUCCESS,
  payload: data,
});

export const timeEntryReduxStateDataFailure = (error) => ({
  type: TIME_ENTRY_REDUX_STATE_DATA_FAILURE,
  payload: error,
});

// Timer is Running
export const timerIsRunning = (data) => ({
  type: TIMER_IS_RUNNING,
  payload: data,
});

export const timerIsRunningSuccess = (data) => ({
  type: TIMER_IS_RUNNING_SUCCESS,
  payload: data,
});

export const timerIsRunningFailure = (error) => ({
  type: TIMER_IS_RUNNING_FAILURE,
  payload: error,
});

//TIMER_STAFF_ID
export const timerStaffId = (data) => ({
  type: TIMER_STAFF_ID,
  payload: data,
});

export const timerStaffIdSuccess = (data) => ({
  type: TIMER_STAFF_ID_SUCCESS,
  payload: data,
});

export const timerStaffIdFailure = (error) => ({
  type: TIMER_STAFF_ID_FAILURE,
  payload: error,
});

//TIMER_BILLABLE_TYPE
export const timerBillableType = (data) => ({
  type: TIMER_BILLABLE_TYPE,
  payload: data,
});

export const timerBillableTypeSuccess = (data) => ({
  type: TIMER_BILLABLE_TYPE_SUCCESS,
  payload: data,
});

export const timerBillableTypeFailure = (error) => ({
  type: TIMER_BILLABLE_TYPE_FAILURE,
  payload: error,
});

//TIMER_TIME_ENTRY_START_DATE_TIME
export const timerTimeEntryStartDateTime = (data) => ({
  type: TIMER_TIME_ENTRY_START_DATE_TIME,
  payload: data,
});

export const timerTimeEntryStartDateTimeSuccess = (data) => ({
  type: TIMER_TIME_ENTRY_START_DATE_TIME_SUCCESS,
  payload: data,
});

export const timerTimeEntryStartDateTimeFailure = (error) => ({
  type: TIMER_TIME_ENTRY_START_DATE_TIME_FAILURE,
  payload: error,
});

//TIMER_TIME_ENTRY_END_DATE_TIME

export const timerTimeEntryEndDateTime = (data) => ({
  type: TIMER_TIME_ENTRY_END_DATE_TIME,
  payload: data,
});

export const timerTimeEntryEndDateTimeSuccess = (data) => ({
  type: TIMER_TIME_ENTRY_END_DATE_TIME_SUCCESS,
  payload: data,
});

export const timerTimeEntryEndDateTimeFailure = (error) => ({
  type: TIMER_TIME_ENTRY_END_DATE_TIME_FAILURE,
  payload: error,
});

// TIMER_JOB_ID
export const timerJobId = (data) => ({
  type: TIMER_JOB_ID,
  payload: data,
});

export const timerJobIdSuccess = (data) => ({
  type: TIMER_JOB_ID_SUCCESS,
  payload: data,
});

export const timerJobIdFailure = (error) => ({
  type: TIMER_JOB_ID_FAILURE,
  payload: error,
});

// Timer TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID
export const timerTimeRecordTypeUnbillableId = (data) => ({
  type: TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID,
  payload: data,
});

export const timerTimeRecordTypeUnbillableIdSuccess = (data) => ({
  type: TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_SUCCESS,
  payload: data,
});

export const timerTimeRecordTypeUnbillableIdFailure = (error) => ({
  type: TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_FAILURE,
  payload: error,
});

//TIMER_NOTES
export const timerNotes = (data) => ({
  type: TIMER_NOTES,
  payload: data,
});

export const timerNotesSuccess = (data) => ({
  type: TIMER_NOTES_SUCCESS,
  payload: data,
});

export const timerNotesFailure = (error) => ({
  type: TIMER_NOTES_FAILURE,
  payload: error,
});

// Active Timer Tab
export const activeTimerTab = (data) => ({
  type: TIME_ACTIVE_TAB,
  payload: data,
});

export const activeTimerTabSuccess = (data) => ({
  type: TIME_ACTIVE_TAB_SUCCESS,
  payload: data,
});

export const activeTimerTabFailure = (error) => ({
  type: TIME_ACTIVE_TAB_FAILURE,
  payload: error,
});

// Pause Timer

export const pauseTimer = (data) => ({
  type: PAUSE_TIMER,
  payload: data,
});

// Add Product Id
export const addProductId = (data) => ({
  type: ADD_PRODUCT_ID,
  payload: data,
});

export const addProductIdSuccess = (data) => ({
  type: ADD_PRODUCT_ID_SUCCESS,
  payload: data,
});

export const addProductIdFailure = (error) => ({
  type: ADD_PRODUCT_ID_FAILURE,
  payload: error,
});

// Add New Time Entry Non Billable Type
export const addNewTimeEntryNonBillableType = (data) => ({
  type: ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE,
  payload: data,
});

export const addNewTimeEntryNonBillableTypeSuccess = (data) => ({
  type: ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  payload: data,
});

export const addNewTimeEntryNonBillableTypeFailure = (error) => ({
  type: ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  payload: error,
});

// Delete Time Entry Non Billable Type
export const deleteTimeEntryNonBillableType = (data) => ({
  type: DELETE_TIME_ENTRY_NON_BILLABLE_TYPE,
  payload: data,
});

export const deleteTimeEntryNonBillableTypeSuccess = (data) => ({
  type: DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  payload: data,
});

export const deleteTimeEntryNonBillableTypeFailure = (error) => ({
  type: DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  payload: error,
});

// Update Time Entry Non Billable Type
export const updateTimeEntryNonBillableType = (data) => ({
  type: UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE,
  payload: data,
});

export const updateTimeEntryNonBillableTypeSuccess = (data) => ({
  type: UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS,
  payload: data,
});

export const updateTimeEntryNonBillableTypeFailure = (error) => ({
  type: UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE,
  payload: error,
});

// Delete Selected Time Entries
export const deleteSelectedTimeEntries = (data) => ({
  type: DELETE_SELECTED_TIME_ENTRIES,
  payload: data,
});

export const deleteSelectedTimeEntriesSuccess = (data) => ({
  type: DELETE_SELECTED_TIME_ENTRIES_SUCCESS,
  payload: data,
});

export const deleteSelectedTimeEntriesFailure = (error) => ({
  type: DELETE_SELECTED_TIME_ENTRIES_FAILURE,
  payload: error,
});

//ACTION_EVENT_FIRED
export const actionEventFired = (data) => ({
  type: ACTION_EVENT_FIRED,
  payload: data,
});

export const actionEventFiredSuccess = (data) => ({
  type: ACTION_EVENT_FIRED_SUCCESS,
  payload: data,
});

export const actionEventFiredFailure = (error) => ({
  type: ACTION_EVENT_FIRED_FAILURE,
  payload: error,
});

// Time Entry List Summary Daily
export const timeEntryListSummaryDaily = (data) => ({
  type: TIME_ENTRY_LIST_SUMMARY_DAILY,
  payload: data,
});
export const timeEntryListSummaryDailySuccess = (data) => ({
  type: TIME_ENTRY_LIST_SUMMARY_DAILY_SUCCESS,
  payload: data,
});
export const timeEntryListSummaryDailyFailure = (error) => ({
  type: TIME_ENTRY_LIST_SUMMARY_DAILY_FAILURE,
  payload: error,
});

// Time Entry Create
export const timeEntryCreate = (data) => ({
  type: TIME_ENTRY_CREATE,
  payload: data,
});
export const timeEntryCreateSuccess = (data) => ({
  type: TIME_ENTRY_CREATE_SUCCESS,
  payload: data,
});
export const timeEntryCreateFailure = (error) => ({
  type: TIME_ENTRY_CREATE_FAILURE,
  payload: error,
});

// Time Entry List Summary Daily By Activity
export const timeEntryListSummaryDailyByActivity = (data) => ({
  type: TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY,
  payload: data,
});
export const timeEntryListSummaryDailyByActivitySuccess = (data) => ({
  type: TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_SUCCESS,
  payload: data,
});
export const timeEntryListSummaryDailyByActivityFailure = (error) => ({
  type: TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_FAILURE,
  payload: error,
});
